import { render, staticRenderFns } from "./AttendanceListItem.vue?vue&type=template&id=0236af0e&scoped=true"
import script from "./AttendanceListItem.vue?vue&type=script&lang=js"
export * from "./AttendanceListItem.vue?vue&type=script&lang=js"
import style0 from "./AttendanceListItem.vue?vue&type=style&index=0&id=0236af0e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0236af0e",
  null
  
)

export default component.exports
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTooltip,QBadge});
